<template>
  <div class="step">
    <img class="icon" :src="require(`@/assets/icons/${image}`)"/>
    <div class="step-title">{{ title }}</div>
    <div class="content">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'RollingCreditStepContent',
  props: {
    image: String,
    title: String,
    text: String,
  },
};
</script>

<style scoped lang="scss">

.step {
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 20px;

  .step-title {
    font-weight: bold;
  }

  .icon {
    width: 16px;
  }
}

</style>
